// this directive uses interact.io library: http://interactjs.io/docs/
angular.module('dnecom')
    .directive('draggableImg', ['$document', '$timeout', function ($document, $timeout) {
        var restrictConfig = {
            restriction: 'parent',
            endOnly: false,
            elementRect: {
                top: 0,
                left: 0,
                bottom: 1,
                right: 1
            }
        };

        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                var dragMoveListener = function(event) {
                    var target = event.target;

                    var x = (parseInt($(target).data('x')) || 0) + event.dx;
                    var y = (parseInt($(target).data('y')) || 0) + event.dy;

                    setElementPosition(target, x, y);

                    scope.$emit('draggableImg.update', element);
                };

                var setElementPosition = function(element, x, y) {
                    element.style.webkitTransform = element.style.transform = 'translate(' + x + 'px, ' + y + 'px)';
                    $(element).data('x', x);
                    $(element).data('y', y);
                };

                $timeout(function() {
                    var x = element.data('x') || 0;
                    var y = element.data('y') || 0;

                    setElementPosition(element.get(0), x, y);

                    element.width(element.data('width') + 'px');
                    element.width(element.data('height') + 'px');
                });

                window.interact(element.get(0))
                    .draggable({
                        snap: {
                            targets: [
                                interact.createSnapGrid({
                                    x: 30,
                                    y: 30,
                                    offset: {
                                        x: element.offset().left,
                                        y: element.offset().top + 5 // for unknown reason image appears 5px higher than it should, so we fix it manually
                                    }
                                })
                            ],
                            relativePoints: [
                                {
                                    x: 0,
                                    y: 0
                                }
                            ]
                        },
                        onmove: dragMoveListener,
                        restrict: restrictConfig
                    })
                    .resizable({
                        preserveAspectRatio: true,
                        edges: {
                            left: true,
                            right: true,
                            bottom: true,
                            top: true
                        },
                        restrict: restrictConfig
                    })
                    .on('resizemove', function (event) {
                        var target = event.target;

                        var x = (parseInt(element.data('x')) || 0);
                        var y = (parseInt(element.data('y')) || 0);

                        target.style.width  = event.rect.width + 'px';
                        target.style.height = event.rect.height + 'px';

                        x += event.deltaRect.left;
                        y += event.deltaRect.top;

                        setElementPosition(target, x, y);

                        scope.$emit('draggableImg.update', element);
                    })
                    .on('resizeend', function(event) {
                        element.data('width', element.width());
                        element.data('height', element.height());

                        scope.$emit('draggableImg.update', element);
                    })
                ;

                scope.$on('draggableImg.updatePosition', function($event, position) {
                    element.width(position.width + 'px');
                    element.height(position.height + 'px');

                    setElementPosition(element.get(0), position.x, position.y);
                });

                scope.$on('draggableImg.centerHorizontally', function($event) {
                    var x = parseInt((element.parent().innerWidth() - element.width()) / 2);
                    var y = (parseInt(element.data('y')) || 0);

                    setElementPosition(element.get(0), x, y);
                });

                scope.$on('draggableImg.centerVertically', function($event) {
                    var x = (parseInt(element.data('x')) || 0);
                    var y = parseInt((element.parent().innerHeight() - element.height()) / 2);

                    setElementPosition(element.get(0), x, y);
                });
            }
        }
    }]);
